import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${props => props.theme.spacing.large};
    border-radius: ${props => props.theme.spacing.xsmall};
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
    background: #ffffff;
    text-align: left;
`;

export const DescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    max-width: 800px;
`;

export const Dates = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    color: ${props => props.theme.colours.textDark};
    font-size: ${props => props.theme.fontSize.medium};
    margin: ${props => props.theme.spacing.normal};
`;

export const Title = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    color: ${props => props.theme.colours.textGreen};
    font-size: ${props => props.theme.fontSize.large2};
    font-weight: 700;
    text-align: center;
    margin: ${props => props.theme.spacing.normal};
    max-width: 70%;
`;

export const Blurb = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    color: ${props => props.theme.colours.textDark};
    font-size: ${props => props.theme.fontSize.medium};
    text-align: center;
    margin: ${props => props.theme.spacing.normal};
    line-height: ${props => props.theme.lineHeight.normal};

    & > strong {
        font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    }
`;

export const BlurbWithReducedWidth = styled(Blurb)`
    @media (min-width: ${props => props.theme.widths.mobileMax}) {
        width: 90%;
    }
    @media (min-width: 701px) {
        width: 70%;
    }
`;

export const ScheduleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 800px;
`;

export const DayWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    margin: 12px 0;
`;

export const DateWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    min-width: 54px;
`;

export const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: left;
    border-left: 2px solid;
    border-color: ${props =>
        props.theme.componentColours.upcomingRounds.divider};
    margin: 0 ${props => props.theme.spacing.normal};
    padding: 0 ${props => props.theme.spacing.normal};
`;

export const DayNumber = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    color: ${props => props.theme.colours.textDark};
    font-size: ${props => props.theme.fontSize.medium};
    font-weight: 700;
    margin-bottom: ${props => props.theme.spacing.small};
`;

export const Month = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    color: ${props => props.theme.colours.textDark};
    font-size: ${props => props.theme.fontSize.xsmall};
    font-weight: 700;
`;

export const DayName = styled.div`
    text-align: left;
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    color: ${props => props.theme.colours.textDark};
    font-size: ${props => props.theme.fontSize.medium};
    font-weight: 700;
    margin-bottom: ${props => props.theme.spacing.normal};
`;

export const DayInfo = styled.span`
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    color: ${props => props.theme.colours.textDark};
    font-size: ${props => props.theme.fontSize.medium};
    line-height: ${props => props.theme.lineHeight.normal};
`;

export const DayInfoWithBottomGutter = styled(DayInfo)`
    padding: 0 0 ${props => props.theme.spacing.normal} 0;
`;

export const Jackpot = styled.span`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    color: ${props => props.theme.colours.textDark};
    font-size: ${props => props.theme.fontSize.medium};
    font-weight: 700;
`;
